import { PaymentMethodListUI } from '../../../components/payment-methods/list/payment-method-list-ui';
import { ContextToProps } from '../context-to-props';

export const PaymentMethodsDefaultList = () => {
  return <ContextToProps.List stripeComponent={PaymentMethodListUI} justifiComponent={PaymentMethodListUI} />;
};
